import React, { useState, useEffect } from "react";
import "./DarkModeToggle.css";
import sunIcon from "../assets/sun-icon.png";

function DarkModeToggle({ isMenuHidden = false }) {
  const [isDarkMode, setIsDarkMode] = useState(true);

  // Initialize theme based on user preference, default to dark
  useEffect(() => {
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme === "light") {
      setIsDarkMode(false);
      document.body.classList.remove("dark-mode");
    } else {
      setIsDarkMode(true);
      document.body.classList.add("dark-mode");
    }
  }, []);

  // Toggle between light and dark mode
  const toggleDarkMode = () => {
    if (isDarkMode) {
      document.body.classList.remove("dark-mode");
      localStorage.setItem("theme", "light");
    } else {
      document.body.classList.add("dark-mode");
      localStorage.setItem("theme", "dark");
    }
    setIsDarkMode(!isDarkMode);
  };

  return (
    <div
      className={`dark-mode-toggle${isMenuHidden ? " is-hidden" : ""}`}
      aria-hidden={isMenuHidden}
    >
      <label className="switch">
        <input
          type="checkbox"
          checked={isDarkMode}
          onChange={toggleDarkMode}
          tabIndex={isMenuHidden ? -1 : 0}
        />
        <span className={`slider round ${isDarkMode ? "dark" : "light"}`}>
          <div className="toggle-circle">
            <img
              src={sunIcon}
              alt="Mode"
              className="sun-icon"
              draggable={false}
            />
          </div>
        </span>
      </label>
      {/* <div className="mode-text">{isDarkMode ? "DARK MODE" : "LIGHT MODE"}</div> */}
    </div>
  );
}

export default DarkModeToggle;
